<template>
  <Modal 
    class="week-modal"
    :show="data.show"
    :hasClose="false"
    :closeOnClickLayer="true"
  >
    <template slot="content">
      <div class="gkLoading-content">
        <gkLoading color="white" />
        <p class="word">下载中...</p>
      </div>
    </template>
  </Modal>
</template>

<script>
import gkLoading from 'gkui/loading'
import Modal from './Modal'
// import { mapState } from 'vuex'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  // computed: {
  //   ...mapState([
  //     'isMobile'
  //   ])
  // },
  components: {
    Modal,
    gkLoading
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.week-modal {
  ::v-deep .content {
    background: transparent;
  }
  .word {
    color: #fff;
    margin-top: 30px;
  }
}
</style>